import { ISearchPredictorResult } from "./ISearchPredictorResult";
import { SearchTypeaheadBase } from "./SearchTypeaheadBase";

$(document).ready(function () {
    let sp = new AdvancedSearchTypeahead();
});

export class AdvancedSearchTypeahead extends SearchTypeaheadBase {
        
    private _initialised: boolean = false;  

    constructor(
        textboxId: string = "#txtSearchString",
        protected _url: string = "/SearchPredictor/GetValuesAsObjects/"
    ) {
        super($(textboxId));
        this.init();
    }

    private init = () => {
        if (this._initialised) {
            return;
        }
        this.addHandlers();      
        this.initialiseTypeahead(this.getUrl());
        this._initialised = true;
    }

    private addHandlers = (): void => {
        let self = this;      

        $("#em").change(function () {
            self.initialiseTypeahead(self.getUrl());
        });

        $("input:radio[name='rt']").change(function () {
            self.initialiseTypeahead(self.getUrl());
        });
    }

    private getUrl = (): string => {
        let recordType: string =  <string>$("input:radio[name='rt']:checked").val();
        let isExact: boolean = $('#em').is(":checked");
        let url: string = this._url;

        switch (recordType) {
            case 'source':
                url += 'AdvancedSearch' + (isExact ? 'Exact' : '') + '_Source';
                break;
            case 'event':
                url += 'AdvancedSearch' + (isExact ? 'Exact' : '') + '_Event';
                break;
            case 'desig':
                url += 'AdvancedSearch' + (isExact ? 'Exact' : '') + '_Designation';
                break;
            default: // monument
                url += 'AdvancedSearch' + (isExact ? 'Exact' : '') + '_Monument';
                break;
        }
        return url;
    }  

}